import React from 'react';
import PropTypes from 'prop-types';

const GreenTick = ({ fill = '', style = {} }) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={style}
  >
    <circle cx="9" cy="9" r="9" fill={fill || 'var(--SUCCESS_STATUS)'} />
    <path
      d="M12.3494 5.86965L7.52098 10.352L6.01373 8.77444C5.63904 8.38222 5.01735 8.36801 4.62513 8.74269C4.23291 9.11737 4.2187 9.73907 4.59338 10.1313L6.77075 12.4105C7.14173 12.7989 7.75583 12.8172 8.14933 12.4517L13.6862 7.30888C14.0837 6.93973 14.1066 6.3183 13.7375 5.92086C13.3683 5.52343 12.7469 5.5005 12.3494 5.86965Z"
      fill="white"
    />
  </svg>
);

GreenTick.propTypes = {
  fill: PropTypes.string,
  style: PropTypes.object,
};

export default GreenTick;
